import { Box } from '@mui/system';
import React, { ComponentType, useState } from 'react';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
import { CabinetHeader } from 'src/components/cabinet-header';
import { Sidebar } from 'src/components/sidebar';
import useStyles from './styles';

export const BaseLayout: ComponentType<{ children: any }> = ({ children }) => {
  const classes = useStyles();

  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box className={classes.root}>
      <Sidebar width={252} mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      <Box className={classes.main}>
        <Box className={classes.header}>
          <CabinetHeader handleDrawerToggle={handleDrawerToggle} />
        </Box>
        <SimpleBar className={classes.content}>{children}</SimpleBar>
      </Box>
    </Box>
  );
};
